// Vercel Analytics utilities for enhanced tracking
import { track } from "@vercel/analytics";

// Custom event tracking for business conversions
export const trackBusinessEvent = (
  eventName: string,
  properties?: Record<string, any>
) => {
  track(eventName, {
    timestamp: new Date().toISOString(),
    page: window.location.pathname,
    referrer: document.referrer,
    ...properties,
  });
};

// Track quote requests
export const trackQuoteRequest = (
  productType: string,
  contactMethod: string
) => {
  trackBusinessEvent("quote_request", {
    product_type: productType,
    contact_method: contactMethod,
    category: "lead_generation",
  });
};

// Track contact form submissions
export const trackContactSubmission = (inquiryType: string) => {
  trackBusinessEvent("contact_form_submit", {
    inquiry_type: inquiryType,
    category: "lead_generation",
  });
};

// Track product gallery interactions
export const trackGalleryInteraction = (
  action: string,
  productName: string,
  category: string
) => {
  trackBusinessEvent("gallery_interaction", {
    action,
    product_name: productName,
    product_category: category,
    category: "product_engagement",
  });
};

// Track 360° view usage
export const track360ViewUsage = (productName: string, duration: number) => {
  trackBusinessEvent("360_view_interaction", {
    product_name: productName,
    view_duration_seconds: Math.round(duration / 1000),
    category: "product_engagement",
  });
};

// Track phone calls (when WhatsApp/Call buttons are clicked)
export const trackCallIntent = (
  type: "whatsapp" | "phone",
  context: string
) => {
  trackBusinessEvent("call_intent", {
    contact_type: type,
    context,
    category: "lead_generation",
  });
};

// Track social sharing
export const trackSocialShare = (platform: string, content: string) => {
  trackBusinessEvent("social_share", {
    platform,
    content,
    category: "social_engagement",
  });
};

// Track search usage in gallery
export const trackGallerySearch = (
  searchTerm: string,
  resultsCount: number
) => {
  trackBusinessEvent("gallery_search", {
    search_term: searchTerm,
    results_count: resultsCount,
    category: "product_discovery",
  });
};

// Track page performance metrics
export const trackPagePerformance = (pageName: string, loadTime: number) => {
  trackBusinessEvent("page_performance", {
    page_name: pageName,
    load_time_ms: loadTime,
    category: "performance",
  });
};

// Track local business interactions
export const trackLocalBusinessInteraction = (
  action: string,
  details?: string
) => {
  trackBusinessEvent("local_business_interaction", {
    action,
    details,
    category: "local_engagement",
  });
};
